var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"border border-dark"},[_c('h4',[_c('md-icon',{attrs:{"icon":_vm.icon}}),_vm._v(" "+_vm._s(_vm.title)+" "),_vm._t("append-title")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }